import { Component, OnInit, Input } from '@angular/core';
import { NgxPopupComponent } from '../ngx-popups/ngx-popups/ngx-popups';
export type ShortcutPlatform = 'windows' | 'mac';

@Component({
    selector: 'app-keyboard-shortcuts',
    templateUrl: './keyboard-shortcuts.component.html',
    styleUrls: ['./keyboard-shortcuts.component.scss'],
    standalone: false
})
export class KeyboardShortcutsComponent implements OnInit {
  @Input() popup: NgxPopupComponent;

  platform: ShortcutPlatform = 'windows';

  constructor() { }

  ngOnInit() {
  }

}
